import { FEATURE_REGISTRY } from './registry';
import { FeatureKey } from './types';

export const STUDIO_BACKLOG_FEATURE_KEYS = [
  FeatureKey.AI_ASSISTANT,
  FeatureKey.AI_CONTENT,
  FeatureKey.AI_AUTOMATION,
  FeatureKey.LIVE_STREAMING,
  FeatureKey.PUBLIC_API,
  FeatureKey.WEBHOOKS,
] as const satisfies readonly FeatureKey[];

export type StudioBacklogFeatureKey = (typeof STUDIO_BACKLOG_FEATURE_KEYS)[number];

export const STUDIO_MODULE_LABELS: Partial<Record<FeatureKey, string>> = {
  [FeatureKey.CIRCLES]: 'Circles',
  [FeatureKey.EMAIL_MARKETING]: 'Email Marketing',
  [FeatureKey.NEWSLETTERS]: 'Newsletters',
  [FeatureKey.ANALYTICS]: 'Analytics',
  [FeatureKey.AFFILIATE_MANAGER]: 'Affiliate Manager',
  [FeatureKey.REFERRAL_SYSTEM]: 'Referrals',
  [FeatureKey.CUSTOM_DOMAIN]: 'Custom Domains',
  [FeatureKey.EVENTS]: 'Events',
  [FeatureKey.AUDIENCE]: 'Audience',
  [FeatureKey.OFFERS]: 'Offers',
  [FeatureKey.COURSES]: 'Courses',
  [FeatureKey.MEMBERSHIPS]: 'Memberships',
};

export function isStudioBacklogFeature(key: FeatureKey): boolean {
  return FEATURE_REGISTRY[key]?.studioBacklog === true;
}

export function formatStudioModuleLabel(key: FeatureKey): string {
  return STUDIO_MODULE_LABELS[key] ?? FEATURE_REGISTRY[key]?.name ?? key;
}
